import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { PaginazioneDTO } from "@app/shared/dto/paginazioneDTO";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";

@Injectable({
  providedIn: 'root'
})
export class MapperPaginazione
  implements MapperInterface<PaginazioneDTO, PaginazioneVO> {
  convertVoToDto(e: PaginazioneVO): PaginazioneDTO {
    let paginazioneDTO = new PaginazioneDTO();
    console.log("MapperPaginazione", e);
    paginazioneDTO.numeroPagina = e.pageNumber;
    paginazioneDTO.risultatiPagina = e.size;
    paginazioneDTO.numeroRisTotali = e.totalElements;
    paginazioneDTO.numeroPagTotali = e.totalPages;

    return paginazioneDTO || new PaginazioneDTO();
  }
  convertDtoToVo(t: PaginazioneDTO): PaginazioneVO {
    let paginazioneVO = new PaginazioneVO;
    console.log("MapperPaginazione", t);
    paginazioneVO.pageNumber = t.numeroPagina;
    paginazioneVO.size = t.risultatiPagina;
    paginazioneVO.totalElements = t.numeroRisTotali;
    paginazioneVO.totalPages = t.numeroPagTotali;

    return paginazioneVO || new PaginazioneVO();
  }
  convertListVoToDto(e: PaginazioneVO[]): PaginazioneDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: PaginazioneDTO[]): PaginazioneVO[] {
    throw new Error("Method not implemented.");
  }
}
